const BASE = 'https://edlenimages.edlen.com';

const IMAGE = {
  EVENT: [BASE, 'Branding'].join('/'),
  PRODUCT: [BASE, 'ItemImages'].join('/'),
  BOOTH_SETUP: [BASE, 'Assests'].join('/'),
};

export default IMAGE;
